import {useEffect, useState} from "react";
import {findOrderItemsWithPagination} from "../api/eventGroupApiClient";

export const useOrderItems = (orderId, page, pageSize, reloadTrigger = 0) => {
    const [orderItems, setOrderItems] = useState([]);
    const [pagination, setPagination] = useState(null);

    useEffect(() => {
        const abortController = new AbortController();
        const orderItemsWithPagination = findOrderItemsWithPagination(orderId, page, pageSize, abortController.signal);

        orderItemsWithPagination
            .then(
                (data) => {
                    const orderItems = data.orderItems;
                    const pagination = data.pagination;

                    setOrderItems(orderItems);
                    setPagination(pagination);
                }
            )
            .catch(
                (error) => console.log(error)
            );

        return () => {
            abortController.abort();
        };
    }, [orderId, page, pageSize, reloadTrigger]);

    return {orderItems, pagination};
};
